import { InputAdornment } from "@mui/material";
import { FC } from "react";

import { SVG_MUI } from "@ryde/assets";
import { blueGreyMui } from "@ryde/theme";

export const AdornmentLens: FC = () => {
  return (
    <InputAdornment position="start">
      <SVG_MUI.LensInTextboxSVG style={{ color: blueGreyMui._300 }} />
    </InputAdornment>
  );
};
